import React, { forwardRef, useState } from "react";

interface LabConfirmRemovalModalProps {
  handleRemoveLab: () => Promise<void>;
  handleCancel?: () => void;
  loading?: boolean;
}

export interface LabConfirmRemovalModalRef {
  showModal: () => void;
  close: () => void;
}

export const LabConfirmRemovalModal = forwardRef<LabConfirmRemovalModalRef, LabConfirmRemovalModalProps>(({ 
  handleRemoveLab, 
  handleCancel 
}, ref) => {
  const [loading, setLoading] = useState(false);
  const dialogRef = React.useRef<HTMLDialogElement>(null);
  
  React.useImperativeHandle(ref, () => ({
    showModal: () => dialogRef.current?.showModal(),
    close: () => dialogRef.current?.close()
  }));

  return (
    <dialog ref={dialogRef} className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Confirm Lab Removal</h3>
        <p className="py-4">
          Are you sure you want to delete this lab? This action cannot be undone.
          All members will be removed from the lab.
        </p>
        <form method="dialog">
          <div className="modal-action">
            <button
              className="btn btn-error"
              onClick={async (e) => {
                e.preventDefault()
                setLoading(true);
                try {
                  await handleRemoveLab();
                  dialogRef.current?.close();
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading loading-spinner loading-sm"></span>
                  Deleting...
                </>
              ) : (
                'Delete Lab'
              )}
            </button>
            <button
              className="btn btn-outline"
              disabled={loading}
              onClick={() => {
                if (handleCancel) handleCancel();
                dialogRef.current?.close();
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </dialog>
  );
});

LabConfirmRemovalModal.displayName = 'LabConfirmRemovalModal';